import { Model } from '@vuex-orm/core'
import { Request } from '@vuex-orm/plugin-axios'
import RatePlan from './RatePlan'
import { getCode } from '@/lang'
import AppState from '@/utils/app.state'
import { LangedItem } from './common/commons'
import { extractTranslation } from '@/lang/helper'

export default class PaymentPolicy extends Model {
  declare id: string
  declare friendlyName?: string
  declare description?: LangedItem[]
  declare ratePlanIds: string[]
  declare ratePlans: RatePlan[]

  static entity = 'paymentPolicies'

  static fields() {
    return {
      id: this.attr(null),
      friendlyName: this.string(null).nullable(),
      description: this.attr(null).nullable(),
      ratePlanIds: this.attr(null),
      ratePlans: this.hasManyBy(RatePlan, 'ratePlanIds'),
      // sequence: this.attr(null),
    }
  }

  get langedDescription() {
    return extractTranslation(this.description)
  }

  static apiConfig = {
    actions: {
      fetch(this: Request) {
        return this.post(
          '/content/v2/policies/getpaymentpoliciesbypropertyids',
          {
            propertyIDs: [AppState.currentProperty],
            languageCodes: [getCode()]
          }
        )
      }
    },
  }
}
